module.exports = __webpack_public_path__ + "img/level_logo6.2a27fa72.png";